import { Update } from '@ngrx/entity';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { createAction } from '@ngrx/store';

import { CaNumber, SingleCaNumberDetails, UpdateCaNumberPayload } from './ca-numbers.model';

export const CaNumbersActions = createActionGroup({
  source: 'CaNumbers/API',
  events: {
    'Load CaNumberss': props<{ caNumberss: CaNumber[] }>(),
    'Add CaNumbers': props<{ caNumbers: CaNumber }>(),
    'Upsert CaNumbers': props<{ caNumbers: CaNumber }>(),
    'Add CaNumberss': props<{ caNumberss: CaNumber[] }>(),
    'Upsert CaNumberss': props<{ caNumberss: CaNumber[] }>(),
    'Update CaNumbers': props<{ caNumbers: Update<CaNumber> }>(),
    'Update CaNumberss': props<{ caNumberss: Update<CaNumber>[] }>(),
    'Delete CaNumber': props<{ id: number }>(),
    'Clear CaNumberss': emptyProps(),
    'Load CaNumberss Success': props<{ caNumberss: CaNumber[] }>(),
    'Load CaNumberss Failure': props<{ error: any }>(),
    'Delete CaNumber Success': props<{ id: number }>(),
    'Delete CaNumber Failure': props<{ error: any }>(),
    'Load Single CaNumber': props<{ id: number }>(),
    'Load Single CaNumber Success': props<{ caNumber: SingleCaNumberDetails }>(),
    'Load Single CaNumber Failure': props<{ error: any }>(),
    'Update CaNumber': props<{ id: number; payload: UpdateCaNumberPayload }>(),
    'Update CaNumber Success': props<{ caNumber: SingleCaNumberDetails }>(),
    'Update CaNumber Failure': props<{ error: any }>(),
    'Add CA From Order': props<{ payload: UpdateCaNumberPayload }>(),
    'Add CA From Order Success': props<{ caNumber: SingleCaNumberDetails }>(),
    'Add CA From Order Failure': props<{ error: any }>(),
  },
});

export const loadCaNumbers = createAction(
  '[CA Numbers] Load',
  props<{ q?: string; offset?: number; limit?: number; sort?: string }>(),
);

export const loadCaNumbersSuccess = createAction(
  '[CA Numbers] Load Success',
  props<{ caNumbers: CaNumber[]; total: number }>(),
);

export const loadCaNumbersFailure = createAction(
  '[CA Numbers] Load Failure',
  props<{ error: any }>(),
);

export const setPage = createAction(
  '[CA Numbers] Set Page',
  props<{ offset: number; limit: number }>(),
);

export const setSort = createAction('[CA Numbers] Set Sort', props<{ sort: string }>());

export const setSearch = createAction('[CA Numbers] Set Search', props<{ q: string }>());

export const deleteCaNumber = createAction(
  '[CaNumbers/API] Delete CaNumber',
  props<{ id: number }>(),
);

export const deleteCaNumberSuccess = createAction(
  '[CaNumbers/API] Delete CaNumber Success',
  props<{ id: number }>(),
);

export const deleteCaNumberFailure = createAction(
  '[CaNumbers/API] Delete CaNumber Failure',
  props<{ error: any }>(),
);

export const loadSingleCaNumberFailure = createAction(
  '[CaNumbers/API] Load Single CaNumber Failure',
  props<{ error: any }>(),
);

export const loadSingleCaNumberSuccess = createAction(
  '[CaNumbers/API] Load Single CaNumber Success',
  props<{ caNumber: SingleCaNumberDetails }>(),
);

export const loadSingleCaNumber = createAction(
  '[CaNumbers/API] Load Single CaNumber',
  props<{ id: number }>(),
);

export const updateCaNumber = createAction(
  '[CaNumbers/API] Update CaNumber',
  props<{ id: number; payload: UpdateCaNumberPayload }>(),
);

export const updateCaNumberSuccess = createAction(
  '[CaNumbers/API] Update CaNumber Success',
  props<{ caNumber: SingleCaNumberDetails }>(),
);

export const updateCaNumberFailure = createAction(
  '[CA Numbers] Update Ca Number Failure',
  props<{ error: any }>(),
);

export const clearSelectedCaNumber = createAction('[CaNumbers/API] Clear Selected CaNumber');

export const addCaNumber = createAction(
  '[CaNumbers/API] Add CaNumber',
  props<{ payload: UpdateCaNumberPayload }>(),
);

export const addCaNumberSuccess = createAction(
  '[CaNumbers/API] Add CaNumber Success',
  props<{ caNumber: SingleCaNumberDetails }>(),
);

export const addCaNumberFailure = createAction(
  '[CaNumbers/API] Add CaNumber Failure',
  props<{ error: any }>(),
);

export const addCaFromOrder = createAction(
  '[CaNumbers/API] Add CA From Order',
  props<{ payload: UpdateCaNumberPayload }>(),
);

export const addCaFromOrderSuccess = createAction(
  '[CaNumbers/API] Add CA From Order Success',
  props<{ caNumber: SingleCaNumberDetails }>(),
);

export const addCaFromOrderFailure = createAction(
  '[CaNumbers/API] Add CA From Order Failure',
  props<{ error: any }>(),
);
